module.exports = __webpack_public_path__ + "media/images/img/banner/bnr_recruit2019-98ad13ff3552d229f221bd845dc6ad81.png";